import set from 'lodash/set';
import sortBy from 'lodash/sortBy';
import mapKeys from 'lodash/mapKeys';
import defaultsDeep from 'lodash/defaultsDeep';
import { VrioContentType } from '@dtvgo/constants';
import { EntityName } from './constants.js';

function typeToEntityName(type) {
  switch (type) {
    case VrioContentType.SHOW: {
      return EntityName.SHOW;
    }
    case VrioContentType.CHANNEL: {
      return EntityName.CHANNEL;
    }
    default: {
      return EntityName.CONTENT;
    }
  }
}
function completeChildrenProps(props) {
  return (childrenName) => (entity) => ({
    ...entity,
    [childrenName]: entity[childrenName]?.map?.((child) => {
      const propsToAdd = {};
      for (const prop of Object.keys(props)) {
        set(propsToAdd, props[prop], entity[prop]);
      }
      return defaultsDeep({}, child, propsToAdd);
    })
  });
}
function sortChildren(childrenName, iteratees) {
  return (entity) => ({
    ...entity,
    [childrenName]: entity[childrenName] && sortBy(entity[childrenName], iteratees)
  });
}
function normalizeGenres({
  genres,
  ...data
}) {
  let normalizedGenres = genres;
  if (genres && typeof genres[0] === "object") {
    normalizedGenres = genres.map(({ name, title }) => title || name);
  }
  return {
    genres: normalizedGenres,
    ...data
  };
}
function greatestCommonDivisor(a, b) {
  let x = a;
  let y = b;
  while (y) {
    const t = y;
    y = x % y;
    x = t;
  }
  return x;
}
function simplify(num, den) {
  const gcd = greatestCommonDivisor(num, den);
  return [num / gcd, den / gcd];
}
function addRatioToImages(entity) {
  return {
    ...entity,
    images: entity.images?.map((image) => {
      const { width, height, ratio } = image;
      if (!ratio && width && height) {
        const [num, den] = simplify(width, height);
        return {
          ratio: `${num}:${den}`,
          ...image
        };
      }
      return image;
    })
  };
}
function convertChildrenArrayToObject(childrenName, getKey) {
  return (entity) => ({
    ...entity,
    [childrenName]: entity[childrenName] ? mapKeys(entity[childrenName], getKey) : {}
  });
}
function convertImageUrlToImageCollection(sourceProp, destinationProp) {
  return ({ [sourceProp]: url, ...entity }) => ({
    [destinationProp]: [{ url }],
    ...entity
  });
}
const genericConvertImagesArrayToObject = (childrenName) => convertChildrenArrayToObject(childrenName, ({ ratio }) => ratio || "unknown");
const convertImagesArrayToObject = genericConvertImagesArrayToObject("images");

export { addRatioToImages, completeChildrenProps, convertChildrenArrayToObject, convertImageUrlToImageCollection, convertImagesArrayToObject, genericConvertImagesArrayToObject, normalizeGenres, sortChildren, typeToEntityName };
//# sourceMappingURL=utils.js.map
